<template>
  <div class="">
    <form class="topform" @submit="sendNotification($event)">
      <div class="row">
        <div class="col">
          <label for="">Kto?</label>
          <select v-model="pickedOption">
            <option
              class="option"
              :value="option.name"
              v-for="option in options"
              :key="option.id"
            >
              {{
                option.name === "selected_phone_numbers"
                  ? option.displayName
                  : option.displayName + " (" + getCounter(option.name) + ")"
              }}
            </option>
          </select>
        </div>
        <div class="col">
          <label for="">Partnerzy</label>
          <select @change="newPartnersPicked" v-model="pickedOptionPartners">
            <option class="option" :value="'none'">Brak</option>
            <option
              class="option"
              :value="option.id"
              v-for="option in partnersArray"
              :key="option.id"
            >
              {{ option.name + " (" + option.amount + ")" }}
            </option>
          </select>
        </div>
        <!-- ZGODY MARKETINGOWE <div class="row checkbox-row">
          <input id="check" v-model="marketingAgreement" type="checkbox" />
          <label for="check"
            >Wyślij również do osób bez zgód marketingowych</label
          >
        </div> -->
      </div>

      <div class="addedNumbers">
        <div v-for="partner in pickedPartners" :key="partner.id">
          {{ partner.name }}
          <i
            class="fas fa-times removeNumberIcon"
            @click="deletePartner(partner)"
          ></i>
        </div>
      </div>

      <div
        v-if="pickedOption === 'selected_phone_numbers'"
        class="selectUsersContainerDiv"
      >
        <form @submit.prevent="addOwnNumber">
          <div class="d-flex w-100">
            <input id="addNumbersCheckbox" v-model="ownNumber" />
            <button type="submit" class="btn btn-outline-dark">
              Dodaj numer
            </button>
          </div>
        </form>
      </div>
      <div
        v-if="pickedOption === 'selected_phone_numbers'"
        class="addedNumbers"
      >
        <div v-for="number in this.phoneNumbers" :key="number">
          {{ number }}
          <i
            class="fas fa-times removeNumberIcon"
            @click="deletePhoneNumber(number)"
          ></i>
        </div>
      </div>

      <div class="input-container">
        <label>Tytuł</label>
        <input
          v-model="title"
          id="title"
          type="text"
          class="form-control"
          required
          minlength="1"
        />
      </div>

      <p class="messageContent">
        <label>Wiadomość:</label>
        <textarea
          id="body"
          rows="10"
          maxlength="2048"
          minlength="20"
          class="form-control"
          required
          style="width: 100%"
          ref="my_input"
          v-model="body"
        >
        </textarea>
        <span class="charsCounter"
          >{{ body.length }}/{{ messageMaxLength }}</span
        >
      </p>

      <div>
        <input
          type="file"
          accept="image/*"
          @change="getImage($event)"
          id="notificationFile"
        />
      </div>
      <button
        class="btn btn-outline-dark"
        type="submit"
        :disabled="isSubmitted"
      >
        Wyślij
      </button>
    </form>

    <div class="adminNotifications">
      <div class="menagment-panel">
        <pagination-inline
          :dispatchAction="`fetchAllAdminNotifications`"
          :onPage="this.notifications.on_page"
          :pageNumber="this.notifications.page_number"
          :total="this.notifications.total"
        ></pagination-inline>
      </div>
      <table
        class="table borderless"
        v-if="
          this.notifications &&
          this.notifications.notifications &&
          this.notifications.notifications.length > 0
        "
      >
        <thead>
          <tr class="tr-table">
            <th scope="col">Data wysłania</th>
            <th scope="col">Tytuł</th>
            <th scope="col">Treść</th>
            <th scope="col">Grupa</th>
            <th scope="col">Lista numerów</th>
            <th scope="col">Zdjęcie</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="notification in this.notifications.notifications"
            :key="notification.id"
          >
            <td>
              {{ formattedDate(notification.creationDate) }}
            </td>

            <td>{{ notification.title }}</td>
            <td>{{ notification.body }}</td>
            <td>
              {{
                notification.users_group
                  ? translateUsersGroup(notification.users_group)
                  : "Brak"
              }}
            </td>
            <td>
              <button
                v-if="notification.users_group === 'PHONE_NUMBERS'"
                type="button"
                class="btn btn-outline-dark"
                data-toggle="modal"
                data-target="#phoneNumbers"
                @click="
                  setAdminNotificationIdToFetchPhoneNumbers(notification.id)
                "
              >
                Lista numerów
              </button>
            </td>
            <td>
              <a
                target="_blank"
                :href="
                  getUrl() + '/api/profile/photo/' + notification.file_path
                "
              >
                <img
                  class="message-img"
                  :src="
                    getUrl() + '/api/profile/photo/' + notification.file_path
                  "
                />
              </a>
            </td>
            <div
              class="modal fade"
              id="phoneNumbers"
              tabindex="-1"
              role="dialog"
              aria-labelledby="phoneNumbers"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="phoneNumbers">Lista numerów</h5>
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div
                    class="modal-body"
                    v-if="notificationPhoneNumbers.length > 0"
                  >
                    <span
                      v-for="number in notificationPhoneNumbers"
                      :key="number"
                      style="margin-right: 1rem"
                      >{{ number }}
                    </span>
                  </div>
                  <div class="modal-body" v-else>
                    <span> Brak </span>
                  </div>

                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-outline-dark"
                      data-dismiss="modal"
                    >
                      Zamknij
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import shared from "../../shared";
import { URL } from "../../axios";
import axios from "../../axios";
import PaginationInline from "../../components/PaginationInline";
export default {
  name: "push-notifications",
  computed: {
    infoMessage() {
      return this.$store.getters.getNotificationResponse;
    },
    notifications() {
      return this.$store.getters.getAllAdminNotifications;
    },
    userGroupsCounter() {
      return this.$store.getters.getUserGroupsCounter;
    },
    partnersArray() {
      return this.$store.getters.getPartners;
    },
  },
  components: {
    PaginationInline,
  },
  async created() {
    this.formattedDate = shared.formattedDate;
    this.fetchAllNotifications();
    this.$store.dispatch("fetchUserGroupsCounter", {});
    await this.$store.dispatch("fetchPartners", {});
    console.log(this.partnersArray);
  },
  data: function () {
    return {
      title: "",
      body: "",
      file: null,
      seniors: true,
      employees: false,
      employees_accepted: false,
      employees_not_finished_payment: false,
      all: false,
      messageMaxLength: 2048,
      ownNumber: "",
      phoneNumbers: [],
      notificationPhoneNumbers: [],
      adminNotificationId: "",
      isSubmitted: false,
      pickedOption: "all",
      pickedPartners: [],
      pickedOptionPartners: "none",
      marketingAgreement: false,
      options: [
        {
          name: "all",
          displayName: "Wszyscy",
        },
        {
          name: "seniors",
          displayName: "Seniorzy",
        },
        {
          name: "employees",
          displayName: "Opiekunowie",
        },
        {
          name: "employees_accepted",
          displayName: "Opiekunowie zweryfikowani",
        },
        {
          name: "employees_not_finished_payment",
          displayName: "Opiekunowie z niedokończoną płatnością weryfikacyjną",
        },
        {
          name: "selected_phone_numbers",
          displayName: "Wybrane numery telefonów",
        },
      ],
    };
  },
  methods: {
    async setAdminNotificationIdToFetchPhoneNumbers(adminNotificationId) {
      this.notificationPhoneNumbers = [];
      this.adminNotificationId = adminNotificationId;
      try {
        const response = await axios.get(
          `/api/notification/${adminNotificationId}/phoneNumbers`
        );
        this.notificationPhoneNumbers = response.data;
      } catch (e) {
        console.log(e);
      }
    },
    deletePhoneNumber(number) {
      const index = this.phoneNumbers.indexOf(number);
      if (index !== -1) {
        this.phoneNumbers.splice(index, 1);
      }
    },
    deletePartner(partner) {
      const index = this.pickedPartners.indexOf(partner);
      if (index !== -1) {
        this.pickedPartners.splice(index, 1);
      }
    },
    addOwnNumber() {
      if (this.ownNumber.includes(" ")) {
        this.ownNumber.split(" ").forEach((number) => {
          if (number && number !== "" && !this.phoneNumbers.includes(number)) {
            this.phoneNumbers.push(number);
          }
        });
        this.ownNumber = null;
      } else {
        if (
          this.ownNumber &&
          this.ownNumber !== "" &&
          !this.phoneNumbers.includes(this.ownNumber)
        ) {
          this.phoneNumbers.push(this.ownNumber);
          this.ownNumber = null;
        } else {
          this.ownNumber = null;
        }
      }
    },
    async fetchAllNotifications() {
      this.$store.dispatch("fetchAllAdminNotifications");
    },
    getUrl() {
      return URL;
    },

    clearInputFile(f) {
      if (f.value) {
        try {
          f.value = ""; //for IE11, latest Chrome/Firefox/Opera...
        } catch (err) {
          console.log(err);
        }
        if (f.value) {
          //for IE5 ~ IE10
          var form = document.createElement("form"),
            ref = f.nextSibling;
          form.appendChild(f);
          form.reset();
          ref.parentNode.insertBefore(f, ref);
        }
      }
    },

    async sendNotification(e) {
      try {
        this.isSubmitted = true;
        e.preventDefault();
        let group_type = this.pickedOption;
        let partnersIDs = [];
        this.pickedPartners.map((partner) => {
          partnersIDs.push(partner.id);
        });
        this.pickedPartners = partnersIDs;
        // console.log(this.marketingAgreement);
        // console.log(partnersIDs);
        // console.log(group_type);
        if (group_type) {
          if (group_type === "selected_phone_numbers") {
            if (this.phoneNumbers.length === 0) {
              this.$notify({
                group: "error",
                text: "Dodaj numery telefonów",
              });
              return;
            }
          }
          if (this.file) {
            const split = this.file.name.split(".");
            const extenstion = split[split.length - 1].toLowerCase();
            if (
              extenstion !== "png" &&
              extenstion !== "jpg" &&
              extenstion !== "jpeg"
            ) {
              this.$notify({
                group: "error",
                text: "Załącznik do wysłania może być tylko formacie [png, jpg, jpeg]",
              });
            } else {
              await this.sendAndNotify(group_type);
            }
          } else {
            await this.sendAndNotify(group_type);
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.isSubmitted = false;
      }
    },
    getCounter(name) {
      if (this.userGroupsCounter !== null) {
        if (name === "all") return this.userGroupsCounter.all;
        if (name === "seniors") return this.userGroupsCounter.seniors;
        if (name === "employees") return this.userGroupsCounter.employees;
        if (name === "employees_accepted")
          return this.userGroupsCounter.employeesAccepted;
        if (name === "employees_not_finished_payment")
          return this.userGroupsCounter.employeesNotFinishedPayment;
      }
    },
    setButton(type) {
      if (type === "seniors") {
        this.seniors = true;
        this.employees = false;
        this.all = false;
        this.singleUser = false;
        this.employees_accepted = false;
        this.employees_not_finished_payment = false;
      }
      if (type === "employees") {
        this.seniors = false;
        this.employees = true;
        this.all = false;
        this.singleUser = false;
        this.employees_accepted = false;
        this.employees_not_finished_payment = false;
      }
      if (type === "employees_accepted") {
        this.seniors = false;
        this.employees = false;
        this.all = false;
        this.singleUser = false;
        this.employees_accepted = true;
        this.employees_not_finished_payment = false;
      }
      if (type === "employees_not_finished_payment") {
        this.seniors = false;
        this.employees = false;
        this.all = false;
        this.singleUser = false;
        this.employees_accepted = false;
        this.employees_not_finished_payment = true;
      }
      if (type === "all") {
        this.seniors = false;
        this.employees = false;
        this.all = true;
        this.singleUser = false;
        this.employees_accepted = false;
        this.employees_not_finished_payment = false;
      }
    },

    translateUsersGroup(group) {
      if (group === "ALL") {
        return "Wszyscy";
      } else if (group === "EMPLOYEES") {
        return "Opiekunowie";
      } else if (group === "EMPLOYEES_ACCEPTED") {
        return "Opiekunowie zweryfikowani";
      } else if (group === "EMPLOYEES_NOT_FINISHED_PAYMENT") {
        return "Opiekunowie z niedokończoną płatnością weryfikacyjną";
      } else if (group === "PHONE_NUMBERS") {
        return "Wybrane numery telefonów";
      } else if (group === "SENIORS") {
        return "Seniorzy";
      } else {
        return "";
      }
    },

    async sendAndNotify(group_type) {
      const obj = {
        title: this.title,
        body: this.body,
        photo: this.file,
        group: group_type,
        phone_numbers:
          group_type === "selected_phone_numbers" ? this.phoneNumbers : [],
        partners_ids: this.pickedPartners,
        not_required_marketing_agreement: true,
      };
      await this.$store.dispatch("sendNotification", obj);
      this.$notify({
        group: "success",
        text: "Powiadomienie zostało wysłane",
      });
      this.fetchAllNotifications();
      (this.title = ""), (this.body = ""), (this.file = null);
      const notificationFileInput = document.querySelector("#notificationFile");
      if (notificationFileInput) {
        notificationFileInput.value = null;
      }
      this.pickedPartners = [];
      this.phoneNumbers = [];
    },
    getImage(e) {
      e.preventDefault();
      this.file = e.target.files[0];
    },
    newPartnersPicked() {
      if (this.pickedOptionPartners === "none") {
        this.pickedPartners = [];
        return;
      }
      this.partnersArray.forEach((partner) => {
        if (partner.id === this.pickedOptionPartners) {
          this.pickedPartners.push({ name: partner.name, id: partner.id });
        }
      });
    },
  },
};
</script>

<style scoped>
.selectUsersContainer {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.selectUsersContainerDiv button {
  min-width: 0px !important;
  margin-top: 5px !important;
}
.addedNumbers {
  display: flex;
  flex-wrap: wrap;
}
.addedNumbers div {
  border: 1px solid rgb(173, 172, 172);
  padding: 5px;
  margin: 3px;
  border-radius: 50px;
  position: relative;
  min-width: 90px;
  padding-right: 20px;
}
.removeNumberIcon {
  cursor: pointer;
  position: absolute;
  right: 6px;
  top: 8px;
}
.col {
  display: flex;
  flex-direction: column;
  width: 300px;
}
.row {
  display: flex;
}

select {
  padding: 5px;
  background: #fff;
  border: none;
  border-radius: 3px;
  color: #090741;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}
.option {
  background: #fff;
  color: #090741;
}
::-moz-selection {
  /* Code for Firefox */
  color: #090741;

  background: #fff;
}

::selection {
  color: #090741;

  background: #fff;
}

div.container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
div.input-container {
  flex-direction: column;
  display: flex;
  margin-top: 10px;
}
button.btn {
  margin-top: 20px;
}
.topform {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}
.input-container,
.messageContent {
  width: 100%;
  min-width: 400px;
}
.adminNotifications {
  margin-top: 40px;
}
.messageContent {
  position: relative;
}
.charsCounter {
  position: absolute;
  bottom: 15px;
  right: 25px;
  font-size: 9px;
}

.sendMessageContainer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 400px;
}
.topform button {
  min-width: 400px;
}
.message-img {
  width: 100px;
  height: 100px;
}
.checkbox-row label {
  margin-top: 7px;
  margin-left: 15px;
  color: #090741;
  font-size: 13px;
}
.checkbox-row {
  margin-left: 30px;
  margin-top: 15px;
}
</style>
